module.exports = __webpack_public_path__ + "static/media/f-fax.7ac65632.svg";